// extracted by mini-css-extract-plugin
module.exports = {"landing":"ye3TIeW5J-go45HlqeTDRg==","card":"HgP+sdPbjxU8sGdA5of7Aw=="};